import { AUTH_RESULTADO_LABELS, ENCAMINHADO_LABELS, STATUS_EVENTO_LABELS } from '../../utils/webhookOpcoes';

// Cor nunca vai sozinha: todo badge carrega rótulo e ícone, para quem não distingue as cores
// (e para impressão em preto e branco) continuar lendo o estado.
const TONES = {
  recebido: ['pill-success', 'bi-check-circle'],
  rejeitado: ['pill-danger', 'bi-x-octagon'],
  erro: ['pill-danger', 'bi-exclamation-triangle'],
  valido: ['pill-success', 'bi-shield-check'],
  invalido: ['pill-danger', 'bi-shield-x'],
  ausente: ['pill-warning', 'bi-shield-exclamation'],
  nao_aplicavel: ['pill-neutral', 'bi-shield-slash'],
  sucesso: ['pill-success', 'bi-arrow-up-right-circle'],
  falha: ['pill-danger', 'bi-arrow-up-right-circle'],
  nao: ['pill-neutral', 'bi-dash-circle'],
  ativo: ['pill-success', 'bi-check-circle'],
  inativo: ['pill-neutral', 'bi-pause-circle'],
};

const LABELS = {
  ...STATUS_EVENTO_LABELS,
  ...AUTH_RESULTADO_LABELS,
  ...ENCAMINHADO_LABELS,
  ativo: 'Ativo',
  inativo: 'Inativo',
};

export default function StatusBadge({ status, label }) {
  const [tone, icone] = TONES[status] || ['pill-neutral', 'bi-circle'];
  return (
    <span className={`pill ${tone}`}>
      <i className={`bi ${icone}`} aria-hidden="true" />
      {label || LABELS[status] || status}
    </span>
  );
}
